import footballModule from './football';
import racingModule from './racing';
import firstDownModule from './firstDown';
import matchdayModule from './matchday';
import cricketModule from "./cricket";
import baseballModule from "./baseball";
import tennisModule from "./tennis"

let modules = [footballModule, racingModule, firstDownModule, matchdayModule,cricketModule,baseballModule,tennisModule];

export default modules;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/index.js